/**
 * Утилиты для определения типа устройства, ОС, браузера
 * Используется для отправки информации об устройстве на backend
 */

export interface DeviceInfo {
  type: 'phone' | 'tablet'
  model: string
  os: string
  osVersion: string
  browser: string
  browserVersion: string
  screenResolution: string
}

/**
 * Определяет тип устройства и его характеристики
 */
export function detectDevice(): DeviceInfo {
  const ua = navigator.userAgent
  const screenWidth = window.screen.width
  const screenHeight = window.screen.height
  
  // Определяем тип устройства по размеру экрана
  // Планшет: >= 768px в обоих измерениях
  const isTablet = screenWidth >= 768 && screenHeight >= 768
  const type: 'phone' | 'tablet' = isTablet ? 'tablet' : 'phone'
  
  // Парсим модель устройства
  const modelMatch = ua.match(/\(([^)]+)\)/)
  let model = 'Unknown'
  if (modelMatch) {
    // Берём первую часть до точки с запятой
    const parts = modelMatch[1].split(';')
    model = parts[0].trim()
    
    // Для Android пытаемся найти модель
    if (/Android/i.test(ua)) {
      // Ищем Build/ или после последней точки с запятой
      const buildMatch = ua.match(/Build\/([^)]+)/)
      if (buildMatch) {
        model = buildMatch[1].split(';')[0].trim()
      } else if (parts.length > 1) {
        // Берём вторую часть для Android (обычно там модель)
        model = parts[1].trim()
      }
    }
  }
  
  // Определяем ОС
  let os = 'Unknown'
  let osVersion = ''
  
  if (/Android/i.test(ua)) {
    os = 'Android'
    const versionMatch = ua.match(/Android ([0-9.]+)/)
    osVersion = versionMatch ? versionMatch[1] : ''
  } else if (/iPad|iPhone|iPod/i.test(ua)) {
    os = 'iOS'
    const versionMatch = ua.match(/OS ([0-9_]+)/)
    osVersion = versionMatch ? versionMatch[1].replace(/_/g, '.') : ''
  } else if (/Windows/i.test(ua)) {
    os = 'Windows'
    const versionMatch = ua.match(/Windows NT ([0-9.]+)/)
    osVersion = versionMatch ? versionMatch[1] : ''
  } else if (/Mac OS X/i.test(ua)) {
    os = 'macOS'
    const versionMatch = ua.match(/Mac OS X ([0-9_]+)/)
    osVersion = versionMatch ? versionMatch[1].replace(/_/g, '.') : ''
  } else if (/Linux/i.test(ua)) {
    os = 'Linux'
  }
  
  // Определяем браузер
  let browser = 'Unknown'
  let browserVersion = ''
  
  if (/Chrome/i.test(ua) && !/Edge|Edg/i.test(ua)) {
    browser = 'Chrome'
    const versionMatch = ua.match(/Chrome\/([0-9.]+)/)
    browserVersion = versionMatch ? versionMatch[1] : ''
  } else if (/Safari/i.test(ua) && !/Chrome|Chromium/i.test(ua)) {
    browser = 'Safari'
    const versionMatch = ua.match(/Version\/([0-9.]+)/)
    browserVersion = versionMatch ? versionMatch[1] : ''
  } else if (/Firefox/i.test(ua)) {
    browser = 'Firefox'
    const versionMatch = ua.match(/Firefox\/([0-9.]+)/)
    browserVersion = versionMatch ? versionMatch[1] : ''
  } else if (/Edge|Edg/i.test(ua)) {
    browser = 'Edge'
    const versionMatch = ua.match(/Edg?\/([0-9.]+)/)
    browserVersion = versionMatch ? versionMatch[1] : ''
  }
  
  return {
    type,
    model,
    os,
    osVersion,
    browser,
    browserVersion,
    screenResolution: `${screenWidth}x${screenHeight}`
  }
}
